import { Device, until } from '@helpers/media';
import useMedia from '@hooks/useMedia';
import Chevron from '@img/icons/icon-chevron-down.svg';
import { FilterSortStyles } from '@stories/Elements/ProductFilters/FilterSort/FilterSort.styles';
import React, { FunctionComponent, useState } from 'react';

export interface FilterSortProps {
  filtersOpen: boolean;
  selectedValue: string;
  viewModel: ProductFilterViewModel;
  onChange: (key: string, value: string[]) => void;
}

const FilterSort: FunctionComponent<FilterSortProps> = ({
  filtersOpen,
  selectedValue,
  viewModel: { filterOptions, title, key },
  onChange,
  ...rest
}) => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const isMobile = useMedia([until(Device.TabletLarge)], [true], false);

  const selected = filterOptions.find((x) => x.value === selectedValue);

  const handleSelect = async (selectedOption: string): Promise<void> => {
    onChange(key, [selectedOption]);
  };

  return (
    <FilterSortStyles.Wrapper
      showYBorders={filtersOpen}
      onMouseEnter={() => {
        if (isMobile) {
          return;
        }

        setIsActive(true);
      }}
      onMouseLeave={() => {
        if (isMobile) {
          return;
        }

        setIsActive(false);
      }}
      onClick={() => setIsActive((isMobile && !isActive) || !isMobile)}
      {...rest}
    >
      {title && <FilterSortStyles.Title>{title}</FilterSortStyles.Title>}
      <FilterSortStyles.Select isActive={isActive}>
        <FilterSortStyles.DropdownIcon isActive={isActive}>
          <Chevron />
        </FilterSortStyles.DropdownIcon>
        <span>{selected?.name}</span>
        <FilterSortStyles.List>
          {filterOptions.map((x) => (
            <FilterSortStyles.Option
              key={x.name}
              value={x.value}
              onClick={() => handleSelect(x.value)}
              isSelected={x.value === selected?.value}
            >
              {x.name}
            </FilterSortStyles.Option>
          ))}
        </FilterSortStyles.List>
      </FilterSortStyles.Select>
    </FilterSortStyles.Wrapper>
  );
};

export default FilterSort;
